import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style as itemStyle } from './segmented-control-item.style.js'

import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'
import { classMap } from 'lit/directives/class-map.js'

@customElement('cse-segmented-control-item')
export class CSESegmentedControlItem extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, itemStyle]

  @property({ attribute: 'active', type: Boolean })
  isActive: boolean = false

  @property({ attribute: 'behind-active', type: Boolean, reflect: true })
  behindActive: boolean = false

  @property({ type: Boolean })
  disabled: boolean = false

  @property({ attribute: 'hide-divider', type: Boolean })
  hideDivider: boolean = false

  @property()
  value: string = ''

  override render() {
    return html`<button
      class="${classMap({
        'cse-segmented-control-item': true,
        'active': this.isActive,
        'behind-active': this.behindActive,
        'disabled': this.disabled,
        'font-body': true,
        'hide-divider': this.hideDivider
      })}"
    >
      <slot></slot>
    </button>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-segmented-control-item': CSESegmentedControlItem,
  }
}
